<template>
	<AppCardPage>
		<WoningDetails
			v-if="addressMetaStore.status === 'complete'"
			v-model="dossierDataStore.data.objectData.address"
			:address-meta="addressMetaStore.data"
		/>
	</AppCardPage>
</template>

<script setup lang="ts">
import { useDossierDataStore } from "@/store/useDossierDataStore";
import { useAddressMetaStore } from "@/store/useAddressMetaStore";

const dossierDataStore = useDossierDataStore();
const addressMetaStore = useAddressMetaStore();
</script>
